import BulkOrderGiftCardsPreviewPage from '../../../components/pages/bulk_order/gift_cards/BulkOrderGiftCardsPreviewPage.vue'
export default {
  components: { BulkOrderGiftCardsPreviewPage }
}
